// AppSidebar.js - the workspace's navigation (pages/tabs.js NAV): the brand, then the pages in groups. On a phone it's a
// drawer the top bar's menu button opens (ids #mobile-<key>, as the walkthroughs expect - reacttour/StartTour.js).
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { NAV } from "../pages/tabs";

export default function AppSidebar({ activeTab, mobile = false, open = false, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const go = (item) => { onClose?.(); navigate(item.to || `/app/${item.key}`); };
  const isActive = (item) => (item.to ? `${location.pathname}${location.search}` === item.to : item.key === activeTab);

  if (mobile && !open) return null;
  const nav = (
    <nav className={`as-sidebar${mobile ? " as-sidebar-mobile" : ""}`} aria-label="Workspace">
      <div className="as-brand">
        <button type="button" className="as-brand-link" onClick={() => go({ key: "dashboard" })}>
          <img src="/logo.svg" alt="" /> <span>Simulate<b>Job</b></span>
        </button>
        {mobile && <button type="button" className="as-icon-btn" onClick={onClose} aria-label="Close the menu"><X size={20} /></button>}
      </div>
      {NAV.map((group, i) => (
        <div key={i} className="as-group">
          {group.map((item) => {
            const Icon = item.icon;
            return (
              <button key={item.key} id={item.to ? `nav-${item.key}` : `${mobile ? "mobile-" : ""}${item.key}`} type="button"
                className={`as-link${isActive(item) ? " as-link-active" : ""}`} aria-current={isActive(item) ? "page" : undefined}
                onClick={() => go(item)} title={item.label}>
                <Icon size={20} aria-hidden="true" /> <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      ))}
    </nav>
  );
  // the wrapper runs the page's full height (the background and the border); the links inside stay in view
  return mobile ? <div className="as-drawer" onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>{nav}</div>
    : <aside className="as-side">{nav}</aside>;
}
